<template>
    <div class="row teaser-section None">

        <div v-if="!loaded" class="loading-icon columns text-center prepend-top noprint">
            <p>
                <img src="/Assets/Campus/Common/img/Icons/loading-blue-50x50.gif" alt="loading..." />
            </p>
        </div>

        <div class="teasercontent columns">

            <div v-if="loaded && !model.successful" class="append-bottom">
                <div class="row">
                    <div class="columns mobile-column">
                        <div>{{ model.message }}</div>
                        <div><a href="/">{{ getTranslation('camp_raum_ToHomepage') }}</a></div>
                    </div>
                </div>
            </div>

            <div v-if="loaded && model.successful">
                <div class="row">
                    <div class="columns mobile-column">
                        <h2>{{ model.resourceName }}</h2>
                        <div v-show="!loadedIsBookable">&nbsp;</div>
                        <div v-show="loadedIsBookable && isBookableOnSelectedDate" style="color: green">{{ getTranslation('camp_raum_BookableOnDay') }}</div>
                        <div v-show="loadedIsBookable && !isBookableOnSelectedDate" style="color: red">{{ getTranslation('camp_raum_NotBookableOnDay') }}</div>
                    </div>
                </div>

                <script id="event-template" type="text/x-kendo-template">
                    <div class="k-event-template">${title}</div>
                    <div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div>
                    # if (description) { #
                    <div class="k-event-template k-event-description">#=description#</div>
                    # } #
                </script>

                <div id="scheduler" style="margin-top: 1rem"></div>
            </div>

            <div v-if="loaded && model.successful" class="prepend-top hide-for-small">
                <div>{{ getTranslation('camp_raum_QrCodeOfPage') }}:</div>
                <img :src="qrUrl" />
            </div>

        </div>
    </div>
</template>
<script>
    import Translation from "../../../_Api/Translation";
    import RaumResResourceQr from "../../../_Api/RaumResResourceQr";

    export default {
        data() {
            return {
                "translationKeys": [
                    "camp_raum_ToHomepage",
                    "camp_raum_BookableOnDay",
                    "camp_raum_NotBookableOnDay",
                    "camp_raum_QrCodeOfPage",
                    "camp_raum_Doppelklick"
                ],
                "resourceId": null,
                "loaded": false,
                "loadedIsBookable": false,
                "isBookableOnSelectedDate": true,
                "translations": null,
                "model": null
            }
        },
        created() {
            let data = this.$parent.$data;
            this.resourceId = data.resourceId;
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {

                var promiseTranslations = Translation.load(this.translationKeys);

                var query = {
                    "resourceId": this.resourceId
                };
                var promiseModel = RaumResResourceQr.load(query);

                var thisSetTranslations = this.setTranslations;
                var thisSetModel = this.setModel;
                var thisSetLoaded = this.setLoaded;
                var thisInitScheduler = this.initScheduler;
                Promise.all([promiseTranslations, promiseModel]).then(data => {

                    var responseTranslations = data[0];
                    var responseModel = data[1];

                    thisSetTranslations(responseTranslations.data);
                    thisSetModel(responseModel.data);
                    thisSetLoaded();

                    // wait for the UI to refresh
                    setTimeout(thisInitScheduler, 300);
                })
            },
            setTranslations(translations) {
                this.translations = translations;
            },
            setModel(model) {
                this.model = model;
            },
            setLoaded() {
                this.loaded = true;
            },
            getTranslation(key) {
                return this.translations[key];
            },
            initScheduler() {

                // --- Config Start ---
                bookableResourceInfos = this.model.bookableResourceInfos;
                bookingUrl = "/" + window.HSLU.scLanguage + "/raum-" + this.model.department.toLowerCase() + "/buchung/";
                bookingUrlAppend = "&redirect=qr";
                doubleClickText = this.getTranslation("camp_raum_Doppelklick");
                // --- Config End ---

                var thisUpdateIsBookableOnSelectedDate = this.updateIsBookableOnSelectedDate;

                if (HSLU.language === 'de') {
                    kendo.culture('de-CH');
                }
                $("#scheduler").kendoScheduler({
                    timezone: "Europe/Zurich",
                    date: new Date(),
                    startTime: new Date(2015, 2, 16, 0, 0), // Startzeit des Kalenders
                    endTime: new Date(2015, 2, 16, 24, 0), // Letzte Zeit des Kalenders
                    showWorkHours: true, // Standardmässig nur Bürozeiten anzeigen
                    workDayStart: new Date(2015, 2, 16, 7, 0), // Startzeit der Bürozeit
                    workDayEnd: new Date(2015, 2, 16, 24, 0), // Letzte Zeit der Bürozeit
                    majorTick: 60,
                    minorTickCount: 1,
                    min: getDayOffset(-7),
                    max: getDayOffset(this.model.numDaysMax - 1),
                    views: [{
                        type: "day",
                        eventTemplate: $("#event-template").html()
                    }],
                    dataBound: function (e) {
                        registerCellEvents(e);
                        thisUpdateIsBookableOnSelectedDate();
                    },
                    editable: false,
                    dataSource: {
                        batch: true,
                        transport: {
                            read: {
                                url: '/api/resourceqr/getresourceevents?resourceId=' + this.resourceId,
                                dataType: "json"
                            }
                        },
                        schema: {
                            model: {
                                id: "eventId",
                                fields: {
                                    eventId: { from: "eventId", type: "number" },
                                    title: { from: "title", defaultValue: "No title", validation: { required: true } },
                                    start: { from: "start", type: "date" },
                                    end: { from: "end", type: "date" },
                                    startTimezone: { from: "startTimezone" },
                                    endTimezone: { from: "endTimezone" },
                                    description: { from: "description" },
                                    recurrenceId: { from: "recurrenceId" },
                                    recurrenceRule: { from: "recurrenceRule" },
                                    recurrenceException: { from: "recurrenceException" },
                                    resourceId: { from: "resourceId", nullable: true },
                                    isAllDay: { from: "isAllDay", type: "boolean" }
                                }
                            }
                        }
                    },
                    group: {
                        resources: ["Resources"],
                        orientation: "horizontal"
                    },
                    resources: [
                        {
                            field: "resourceId",
                            name: "Resources",
                            dataSource: [
                                { text: "Resource", value: this.resourceId, color: "#9f304d" }
                            ],
                            title: "Resource"
                        }
                    ]
                });
            },
            updateIsBookableOnSelectedDate() {
                this.isBookableOnSelectedDate = isResourceBookableOnSelectedDate(this.resourceId);
                this.loadedIsBookable = true;
            }
        },
        computed: {
            qrUrl: function () {
                return "/api/QrCode/Load/?url=" + encodeURIComponent(window.location.href);
            }
        }
    }
</script>
<style scoped>
</style>